var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2674,
    height: 4516,
    viewBox: "0 0 2674 4516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.06 1181.25H1375.26V1422.1H1275.06V1181.25ZM1148.26 1181.25H1248.47V1422.1H1148.26V1181.25ZM1021.47 1181.25H1121.67V1422.1H1021.47V1181.25ZM1502.06 1422.1H1401.86V1181.25H1502.06V1422.1ZM981.99 1210.34V1422.1H914.605V1583.22H1608.92V1422.1H1541.54V1210.34V1183.77H1601.43V1126.48H1573.04L1322.07 953.702H1321.44V942.921H1370.69V903.88L1297.96 903.491L1282.55 846.532V785.153H1240.98V846.532L1225.62 903.491L1152.83 903.88V942.921H1202.13V953.702H1201.5L950.534 1126.48H922.141V1183.77H981.99V1210.34Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.53 1731.86H1102.13V1884.68H1075.53V1731.86ZM989.04 1731.86H1015.63V1884.68H989.04V1731.86ZM1162.02 1731.86H1188.62V1884.68H1162.02V1731.86ZM1334.96 1731.86H1361.55V1884.68H1334.96V1731.86ZM1248.47 1731.86H1275.06V1884.68H1248.47V1731.86ZM1421.4 1731.86H1448V1884.68H1421.4V1731.86ZM1507.89 1731.86H1534.49V1884.68H1507.89V1731.86ZM795.734 1663.98V1753.03L906.341 1754.3H922.142V1936.15H1617.24V1754.3L1727.79 1754.1V1663.98H795.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.443 2551.93H1683.34L1712.46 2433.98H871.855L856.443 2551.93Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.859 3159.82H1740.69L1769.81 3041.87H795.743L782.859 3159.82Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1468.06 2003.41H922.13L882.604 2384.6H1011.1C1011.1 2384.6 1021.51 2062.6 1468.06 2003.41Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.13 2601.33H842.32L802.793 2982.52H902.169C902.169 2982.52 942.716 2668.93 1359.13 2601.33Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.165 315.076C742.925 502.029 363.606 484.644 287.713 547.14C882.605 785.128 914.596 172.264 1361.54 60.189C1196.05 -16.7286 894.225 116.566 832.285 154.782C832.285 154.782 687.938 206.109 591.237 186.103C401.383 146.819 333.414 136.378 333.414 136.378C333.414 136.378 497.598 396.607 722.165 315.076ZM1491.84 87.7221C1540.9 89.5673 1596.47 98.9392 1660.3 120.742C1599.48 128.609 1541.62 151.674 1492.08 187.705C1652.72 273.461 1746.65 222.474 1818.26 198.583C1793.47 194.601 1777.37 166.097 1760.02 156.919C1799.01 127.249 1854 131.28 1888.18 166.339C1882.15 175.42 1874.22 182.898 1865.18 188.385C1889.59 187.463 1926.19 199.408 1942.53 223.882C1952.64 213.393 1925.27 133.513 1924.59 127.006C1938.88 141.817 1973.4 221.211 1967.91 241.023C1962.46 260.835 1946.91 276.277 1927.02 281.619C1929.74 248.793 1899.65 222.765 1864.6 240.538C1843.69 251.172 1815.83 273.364 1757.34 293.37C1820.4 400.589 1914.77 454.926 1972.43 611.238C1967.86 523.395 1883.22 404.668 1829.83 311.191C2078.56 506.205 1969.27 736.375 2312.9 1004.18C2258.89 1007.97 2205.31 1007.53 2152.56 1003.01C2087.9 935.71 2033.79 858.89 1992.27 775.174C1987.55 846.022 1997.76 916.869 2021.88 983.347C1979.14 974.072 1937.18 962.175 1896.29 947.704C1861.82 880.11 1835.81 721.225 1818.94 647.075C1801.49 702.772 1793.86 848.11 1796 906.041C1757.1 887.443 1719.42 866.514 1683.15 843.205C1671.1 790.324 1693.99 610.655 1691.47 556.318C1672.31 593.077 1627.53 757.644 1617.86 797.608C1594.72 780.078 1572.74 760.412 1545.17 734.19C1535.01 724.575 1589.17 498.872 1589.17 498.872L1480.07 673.637C1480.07 673.637 1334.95 582.248 1295.33 386.701C1188.75 422.683 974.591 812.953 526.185 796.394C411.106 792.169 289.95 734.384 231.705 602.06C298.02 664.071 373.087 692.38 451.411 695.245C1036.43 716.806 1095.07 73.1058 1491.84 87.7221Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.427 3219.18H1241.04C996.752 3256.4 894.794 3451.41 858.952 3547.19L1175.32 3472.16L1295.02 3629.98L1350.35 3432.29L1749.94 3343.04L1777.9 3383L1844.31 3425.1C1838.33 3448.17 1826.95 3472.4 1807.85 3497.36C1615.71 3748.85 1000.99 3818.04 594.2 3863.84L594.191 3863.84C473.229 3877.43 368.749 3889.23 297.183 3903.51C245.113 3913.9 175.978 3938.91 112.337 3976.98C96.4871 3981.4 91.0904 3983.73 91.0904 3983.73L88.5137 3767.01L263.004 3604.58L476.876 3641.58L540.079 3724.67L614.903 3605.06L745.675 3574.05L782.427 3219.18Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2054.99 3762.86C2271.24 3452.95 1945.21 3279.5 1945.21 3279.5C2134.82 3473.83 2054.99 3762.86 2054.99 3762.86ZM2464.06 3424.89C2553.37 2959.35 2067.43 2766.28 2067.43 2766.28C2452.25 3065.69 2464.06 3424.89 2464.06 3424.89ZM2149.79 3379.19C2149.79 3379.19 2254.52 3130.03 2104.87 2915.79C1955.22 2701.5 1601.43 2696.55 1601.43 2696.55C1601.43 2696.55 2359.29 2561.99 2528.92 3152.47C2698.55 3742.9 1935.24 3967.15 1783.94 4002.01C1632.59 4036.88 608.257 4086.7 323.889 4121.61C39.5217 4156.48 91.1055 4385.68 91.1055 4385.68C-156.701 4166.43 157.032 3992.49 308.915 3962.14C616.571 3900.67 1587.72 3884.06 1855.46 3533.66C2002.33 3341.32 1805.53 3179.86 1805.53 3179.86C2000.1 3159.95 2149.79 3379.19 2149.79 3379.19Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2603.83 3258.22C2603.83 3258.22 2723.39 3746.53 1844.32 4074.16C1844.32 4074.16 2835.3 3891.19 2603.83 3258.22Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365 4129.06C1365 4129.06 768.215 4108.18 382.089 4193.84C213.773 4231.18 162.578 4286 172.545 4355.78C182.56 4425.52 392.056 4500.3 392.056 4500.3C392.056 4500.3 264.871 4408.08 262.343 4348.31C259.863 4288.53 522.012 4197.58 1365 4129.06Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2674,
    height: 4516,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoLight);
export default __webpack_public_path__ + "static/media/MainLogoLight.3a23664381c984898bb31a55bab0e1b3.svg";
export { ForwardRef as ReactComponent };